export const LIST_MAGAZINE = `homepage/list-magazine`;
